$(function(){
    $(document).on("click", ".event-callendar td.event-callendar__dategrid-cell--hascontent", function() {
        $(".em-calendar-wrapper div.right-events").removeClass('show').addClass('hidden');
        $("#" + $(this).attr("id") + "2").removeClass('hidden').addClass('show');
    });
});
